__turbopack_context__.v({
  "backdrop": "LegalNotice-module__jYmMIG__backdrop",
  "body": "LegalNotice-module__jYmMIG__body",
  "close": "LegalNotice-module__jYmMIG__close",
  "dialog": "LegalNotice-module__jYmMIG__dialog",
  "dialogFoot": "LegalNotice-module__jYmMIG__dialogFoot",
  "dialogHead": "LegalNotice-module__jYmMIG__dialogHead",
  "download": "LegalNotice-module__jYmMIG__download",
  "failed": "LegalNotice-module__jYmMIG__failed",
  "legal-fade-in": "LegalNotice-module__jYmMIG__legal-fade-in",
  "legal-rise-in": "LegalNotice-module__jYmMIG__legal-rise-in",
  "link": "LegalNotice-module__jYmMIG__link",
  "loading": "LegalNotice-module__jYmMIG__loading",
  "notice": "LegalNotice-module__jYmMIG__notice",
});
